<div class="modal-header">
    <h4 class="modal-title">{{ 'company.custom-fields.ai-config.title' | translate }}</h4>
    <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="cancel()"
    ></button>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-12 mb-3">
            <p class="text-muted">
                {{ 'company.custom-fields.ai-config.description' | translate }}
            </p>
        </div>

        <div class="col-12 mb-3">
            <div class="form-check form-switch">
                <input
                    class="form-check-input"
                    type="checkbox"
                    id="aiRecognitionEnabled"
                    [(ngModel)]="aiRecognitionEnabled"
                />
                <label class="form-check-label" for="aiRecognitionEnabled">
                    {{ 'company.custom-fields.ai-config.enable' | translate }}
                </label>
            </div>
        </div>

        <div class="col-12" *ngIf="aiRecognitionEnabled">
            <div class="mb-3">
                <label for="aiPrompt" class="form-label">
                    {{ 'company.custom-fields.ai-config.prompt-label' | translate }}
                    <span class="text-danger">*</span>
                </label>
                <textarea
                    class="form-control"
                    id="aiPrompt"
                    rows="5"
                    [(ngModel)]="aiRecognitionPrompt"
                    [maxlength]="maxPromptLength"
                    [placeholder]="'company.custom-fields.ai-config.prompt-placeholder' | translate"
                ></textarea>
                <div class="form-text d-flex justify-content-between">
                    <span>{{ 'company.custom-fields.ai-config.prompt-help' | translate }}</span>
                    <span
                        [class.text-danger]="remainingCharacters < 50"
                        [class.text-warning]="remainingCharacters >= 50 && remainingCharacters < 100"
                    >
                        {{ remainingCharacters }} / {{ maxPromptLength }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">
        {{ 'company.custom-fields.ai-config.cancel' | translate }}
    </button>
    <button
        type="button"
        class="btn btn-primary"
        (click)="save()"
        [disabled]="aiRecognitionEnabled && (!aiRecognitionPrompt || aiRecognitionPrompt.trim().length === 0)"
    >
        {{ 'company.custom-fields.ai-config.save' | translate }}
    </button>
</div>
